/**
 * NSE tickers are upper-case alphanumerics with `&`, `-`, and `.` in a few
 * names (M&M, BAJAJ-AUTO, and the dot survives in a handful of series).
 * Anything else is a typo, and sending it to the router would render a
 * "Nothing to show" page for a symbol that cannot exist.
 *
 * This is the fallback path now that the symbol box has a typeahead: a reader
 * who knows the code and types it in full should not have to wait for a list
 * to agree with them.
 */
export function normaliseSymbol(raw: string): string | null {
  const symbol = raw.trim().toUpperCase();
  if (!/^[A-Z0-9&.-]{1,20}$/.test(symbol)) return null;
  return symbol;
}
